import React from 'react';

const Demo = ({ isVideoLeft, video, title, description }) => {
	return (
		<div className="row no-gutters">
			<div className={'col-lg-6 embed-responsive embed-responsive-16by9 ' + (isVideoLeft ? '' : 'order-lg-2')}>
				<iframe title={title} className="embed-responsive-item" src={'https://www.youtube.com/embed/' + video} />
			</div>
			<div className={'col-lg-6 my-auto showcase-text ' + (isVideoLeft ? '' : 'order-lg-1')}>
				<h2>{title}</h2>
				<p className="lead mb-0">{description}</p>
			</div>
		</div>
	);
};

export default Demo;
